import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CredfinFavicon from '../images/credfinfav.jpeg'
import AbhicashFavicon from '../images/AbhicashFav.png'
import MicromoneyFavicon from '../images/micromoneyFav.png'
import CredfinLogo from '../images/credfinlogo.png'
import MicromoneyLogo from '../images/MicromoneyLogo.png'
import AbhicashLogo from '../images/AbhicashLogo.png'
import CredfinLightLogo from '../images/credfin.png'

const TENANT_CONFIGS = {
  'admin.credfin.money': {
    COMPANY_NAME: "Credfin",
    COMPANY_NAME_CAPS: "CREDFIN",
    COMPANY_NAME_SMALLCASE: "credfin",
    BASE_URL: 'https://backend.credfin.money/',
    FRONTEND_BASE_URL: 'https://admin.credfin.money/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'cf',
    ESIGN_KEY: "arhamfinance&investmentservicesltd_esign_live",
    WEB_URL: 'https://admin.credfin.money/',
    TITLE: "Loans made Easy",
    FAVICON: CredfinFavicon,
    LOGO: CredfinLogo,
    LIGHT_LOGO: CredfinLightLogo,
    RootcssClassName: "credfin-css",
    BOSS_EMAILID: "mohit.bansal@credfin.money",
    NBFC_NAME_TO_SHOW: "Arham",
    REPORT_DB_KEY: "credfin",
    ADMIN_URL_STRING_SHORT :"credfin.money",
    ADMIN_URL_STRING_SHORT_FULL_URL :"admin.credfin.money",
    NBFC_SHORT:"Arham",
    WEBSITE_URL:"https://credfin.money",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : Arham Finance and Investment Services Ltd',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : 112, DAYANAND ROAD, DARYAGANJ, NEW DELHI-11,NEWDELHI,110002',
      ACCOUNT_NUMBER: 'A/C : 033305006690',
      IFSC_CODE: 'ifsc code : ICIC0000333',
      NBFC_NAME:"Arham Finance and Investment Services Ltd",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.credfin.money/uploadDocuments/",
      MOBILE_NO: "+91-9311226661",
      EMAIL_ID: "recovery@credfin.money",
      FINANCE_MAIL_ID: "finance@credfin.money",
      SUPPORT_MAIL_ID: "support@credfin.money",
      KYC_URL: 'https://admin.crefin.money/kyc/',
      CONFIG_MAIL_ID: "config@credfin.money",
      RECOVERY_MAIL_ID:"recovery@credfin.money",
      APP_LINK:"app.credfin.money/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Credfin Infotech Pvt. Ltd.",
      ADDRESS:"1401,1403, Building No. 43, Chiranjiv Tower",
      AREA:"Opposite Eros Hotel, Nehru Place",
      CITY :"New Delhi- 110019."
    }

  },
  'admin.micromoney.in': {
    COMPANY_NAME: "Micromoney",
    COMPANY_NAME_CAPS: "MICROMONEY",
    COMPANY_NAME_SMALLCASE: "micromoney",
    BASE_URL: 'https://backend.micromoney.in/',
    FRONTEND_BASE_URL: 'https://admin.micromoney.in/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'mm',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://admin.micromoney.in/',
    TITLE: "Small Loans Big Impact",
    FAVICON: MicromoneyFavicon,
    LOGO: MicromoneyLogo,
    LIGHT_LOGO: MicromoneyLogo,
    RootcssClassName: "Micromoney-css",
    BOSS_EMAILID: "mohit.bansal@micromoney.in",
    NBFC_NAME_TO_SHOW: "Yashik",
    REPORT_DB_KEY: "micromoney",
    ADMIN_URL_STRING_SHORT :"micromoney.in",
     ADMIN_URL_STRING_SHORT_FULL_URL :"admin.micromoney.in",
     NBFC_SHORT:"Yashik",
      WEBSITE_URL:"https://micromoney.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : YASHIK FINLEASE PRIVATE LIMITED.',
      BANK_NAME: 'Bank : ICICI BANK LTD',
      BRANCH_NAME: 'Branch : Gurgaon Emaar Palm Square',
      ACCOUNT_NUMBER: 'A/C : 555905000039',
      IFSC_CODE: 'ifsc code : ICIC0005559',
       NBFC_NAME:"YASHIK FINLEASE PRIVATE LIMITED.",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://admin.micromoney.in/uploadDocuments/",
      MOBILE_NO: "+91-9773899027",
      EMAIL_ID: "recovery@micromoney.in",
      FINANCE_MAIL_ID: "finance@micromoney.in",
       SUPPORT_MAIL_ID: "support@micromoney.in",
      KYC_URL: 'https://admin.micromoney.in/kyc/',
      CONFIG_MAIL_ID: "config@micromoney.in",
      RECOVERY_MAIL_ID:"recovery@micromoney.in",
      APP_LINK:"app.micromoney.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Micromoney Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  },
  'adminuat.abhicash.in': {
    COMPANY_NAME: "Abhicash",
    COMPANY_NAME_CAPS: "ABHICASH",
    COMPANY_NAME_SMALLCASE: "abhicash",
    BASE_URL: 'https://backenduat.abhicash.in/',
    // BASE_URL: 'https://backend.abhicash.in/',
    FRONTEND_BASE_URL: 'https://adminuat.abhicash.in/',
     LLM_BASE_URL: 'https://llmbackend.infitouch.in/',
    TENANT_ID: 'ac',
    ESIGN_KEY: "phocket-infotech-private-limited_esign_production",
    WEB_URL: 'https://adminuat.abhicash.in/',
    TITLE: "Instant Loans and Financial Wellness Solutions",
    FAVICON: AbhicashFavicon,
    LOGO: AbhicashLogo,
    LIGHT_LOGO: AbhicashLogo,
    RootcssClassName: "Abhicash-css",
    BOSS_EMAILID: "mohit.bansal@abhicash.in",
    NBFC_NAME_TO_SHOW: "CNMP",
    REPORT_DB_KEY: "abhicash",
    ADMIN_URL_STRING_SHORT :"abhicash.in",
    ADMIN_URL_STRING_SHORT_FULL_URL :"adminuat.abhicash.in",
     NBFC_SHORT:"CNMP",
     WEBSITE_URL:"https://abhicash.in",
    ACCOUNT_DETAILS: {
      COMPANY_NAME: 'Name : CNMP Investments Private Limited',
      BANK_NAME: 'Bank : HDFC, Delhi',
      BRANCH_NAME: 'Branch : CONNAUGHT PLACE',
      ACCOUNT_NUMBER: 'A/C : 50200072791180',
      IFSC_CODE: 'ifsc code : HDFC0001563',
      NBFC_NAME:"CNMP Investments Private Limited",
    },
    MAIL_STRING: {
      WEB_URL_NACH: "https://drive.google.com/open?id=1BicYQIO5j7GKmLOqtsNIMLylFnfbKpNU",
      WEB_URL: "https://adminuat.abhicash.in/uploadDocuments/",
      MOBILE_NO: "+91-9220320064",
      EMAIL_ID: "recovery@abhicash.in",
      FINANCE_MAIL_ID: "finance@abhicash.in",
      SUPPORT_MAIL_ID: "support@abhicash.in",
      KYC_URL: 'https://adminuat.abhicash.in/kyc/',
      CONFIG_MAIL_ID: "config@abhicash.in",
      RECOVERY_MAIL_ID:"recovery@abhicash.in",
      APP_LINK:"app.abhicash.in/cash",
    },
    SECURITY_CHEQUE_ADDRESS:{
      COMPANY_NAME:"Abhicash Infotech Pvt. Ltd.",
      ADDRESS:"410, Enkay Center, Vanijya Nikunj,",
      AREA:"WING A, Plot No A, Udyog Vihar, Phase-V,",
      CITY :"Gurugram, Haryana-122016"
    }

  }
};

const handleURL = ()=>{
    const link = window.location?.host;
  // const link = "admin.credfin.money";
  // const link = "admin.micromoney.in";
  // const link = "admin.abhicash.in";
  // const link = "adminuat.abhicash.in";
  return link
}

const InvalidTenantPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center', margin: '10% 15px' }}>
    <h1>Invalid URL</h1>
    <p>This domain is not configured for access. Please Contact the Developer</p>
  </div>
);

export const Company_DATA = {
  CREDFIN: "Credfin",
  MICROMONEY: "Micromoney",
  ABHICASH: "Abhicash",
}

export const CheckFunction = () => {
  const url = handleURL();
  const tenantConfig = TENANT_CONFIGS[url]
  if (!tenantConfig) {

    return ""
  } 
  return tenantConfig
}



const MainFunction = () => {
  const dispatch = useDispatch()
  
  const url = handleURL();

  const tenantConfig = TENANT_CONFIGS[url]

  if (!tenantConfig) {

    return <InvalidTenantPage />;
  }

  dispatch({ type: 'SET_ACTIVE_TENANT', payload: tenantConfig });
  document.title = tenantConfig.TITLE;

  const rootElement = document.getElementById('phocketApp');
  if (rootElement) {
    rootElement.classList.add(tenantConfig?.RootcssClassName);
  }


  const favicon = document.querySelector('link[rel="shortcut icon"]') ||
    document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/png';
  favicon.href = tenantConfig.FAVICON;
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.appendChild(favicon);
  }


  return <Outlet />;

}

export default MainFunction;

